export const environment = {
  production: true,
  server: '',
  apiUrl: '',
};
